// Shared Firebase client for the app: one initialized App, plus Auth (Identity
// Platform) and Firestore handles. Everything client-side imports auth/db from
// here so there's a single SDK instance.
//
// Config is build-time (client/.env, Vite): VITE_FB_API_KEY, _AUTH_DOMAIN,
// _PROJECT_ID. The apiKey is a public identifier, not a secret — security comes
// from the Firestore rules + custom claims.
//
// HIPAA: the live project must be Identity Platform on Blaze with a signed BAA
// (plain Firebase Auth is not HIPAA-eligible). The emulator doesn't distinguish
// them, so local dev is identical.

import { initializeApp, getApps } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';

const app = getApps().length
  ? getApps()[0]
  : initializeApp({
      apiKey: import.meta.env.VITE_FB_API_KEY,
      authDomain: import.meta.env.VITE_FB_AUTH_DOMAIN,
      projectId: import.meta.env.VITE_FB_PROJECT_ID,
      storageBucket: import.meta.env.VITE_FB_STORAGE_BUCKET, // resident photos (Cloud Storage)
      messagingSenderId: import.meta.env.VITE_FB_MESSAGING_SENDER_ID, // FCM push
      appId: import.meta.env.VITE_FB_APP_ID,                          // FCM push
    });

export const auth = getAuth(app);
export const db = getFirestore(app);

// Optional local-emulator wiring for dev (set VITE_FB_USE_EMULATOR=1).
if (import.meta.env.VITE_FB_USE_EMULATOR === '1') {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
}

export default app;
